import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SidebarMenuRest } from './sidebar-menu.rest';
import { SidebarMenu } from './sidebar-menu.models';
import { SettingsService } from '../../core/settings/settings.service';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: '[smpSidebarMenu]',
  templateUrl: './sidebar-menu.component.html',
  providers: [SidebarMenuRest]
})
export class SidebarMenuComponent implements OnInit {
  @Input() onCollapseToggled: EventEmitter<boolean>;

  private collapseToggledSupsctiption: Subscription;
  public menuElements: SidebarMenu[] = [];
  public onMenuItemsLoaded = new EventEmitter();

  constructor(
    private menuService: SidebarMenuRest,
    private router: Router,
    public settings: SettingsService
    ) { }

  ngOnInit() {
      this.menuService.getMenuItems().subscribe(elems => {
        this.menuElements = elems;
        this.menuElements.forEach(elem => {

          if (elem.childElements.length > 0) {
            elem.isFirstLevel = true;
          }
        } );
        this.onMenuItemsLoaded.next(this.menuElements);
      });
      this.collapseToggledSupsctiption = this.onCollapseToggled.subscribe( data => {
        if (data) {
           this.onSidebarMenuCollapsed();
        }
      });
  }

  private onSidebarMenuCollapsed(){
    this.menuElements.forEach(elem => {
      elem.expanded = false;
    });
  }

}
